module.exports = __webpack_public_path__ + "images/namipa_small03757175349da93b28f71baa01fef057.png";